import React from 'react';
import * as ActionTypes from '../constants/ActionTypes';
import { handleActions } from 'redux-actions';
import * as frontmanStatuses from '../constants/FrontmanStatuses';

const initialSate = {
    frontmanTemplateStatus: frontmanStatuses.NONE,
    frontmanShellStatus: frontmanStatuses.NONE
};

const frontmanReducer = handleActions(
    {
        [ActionTypes.SHELL_SAVE_REQUEST]: state => {
            return { ...state, frontmanShellStatus: frontmanStatuses.SAVING };
        },
        [ActionTypes.SHELL_SAVE_SUCCESS]: state => {
            return { ...state, frontmanShellStatus: frontmanStatuses.SAVED };
        },
        [ActionTypes.SHELL_SAVE_FAILURE]: state => {
            return { ...state, frontmanShellStatus: frontmanStatuses.FAILED };
        },
        [ActionTypes.TEMPLATE_SAVE_REQUEST]: state => {
            return { ...state, frontmanTemplateStatus: frontmanStatuses.SAVING };
        },
        [ActionTypes.TEMPLATE_SAVE_SUCCESS]: state => {
            return { ...state, frontmanTemplateStatus: frontmanStatuses.SAVED };
        },
        [ActionTypes.TEMPLATE_SAVE_FAILURE]: state => {
            return { ...state, frontmanTemplateStatus: frontmanStatuses.FAILED };
        }
    },
    initialSate
);

export { frontmanReducer };



// WEBPACK FOOTER //
// ./src/store/FrontmanStore.js